'use strict';

import {extend, isString} from './../lang';
import Action from './Action';

/**
 * @type {Object}
 * @see http://github.github.io/fetch/#options
 * @see https://learn.javascript.ru/fetch
 */
const OPTIONS = {
  method: 'POST',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
  }
};

export default class Server {
  /**
   * @param {Object} actions
   */
  constructor(actions) {
    this.defaultOptions = extend({}, OPTIONS);
    this.onError = this.onError.bind(this);
    this.addActions(actions);
  }
  /**
   * Adds methods to server object
   * @param {Object} actions
   */
  addActions(actions) {
    for(let key in actions) {
      let action = actions[key];
      if (isString(action)) {
        this.addAction(key, {url: action});
      } else {
        this.addAction(key, action); // action is object
      }
    }
  }
  /**
   * Adds method to server object
   * @param {String} key
   * @param {Object} options
   */
  addAction(key, options) {
    let options_ = extend({}, this.defaultOptions, options);
    let {onError} = this;
    let Constructor = this.constructor.Action();
    let action = new Constructor(options_, {onError}); // usage DI
    this[key] = action;
  }
  /**
   * @param {Object} error
   */
  onError(error) {
    console.warn(error);
    return error;
  }
  /**
   * DI
   * @constructor
   */
  static Action() {
    return Action;
  }
}


// WEBPACK FOOTER //
// ./src/js/classes/Server.js